const SUPPORTED_LOCALE_SET = new Set(["en", "de", "es", "fr"]);

const PLAN_TITLE_TEXT = {
  free: {
    en: "Free",
    de: "Free",
    es: "Free",
    fr: "Free",
  },
  starter: {
    en: "Starter",
    de: "Starter",
    es: "Starter",
    fr: "Starter",
  },
  pro: {
    en: "Pro",
    de: "Pro",
    es: "Pro",
    fr: "Pro",
  },
};

function normalizePlanLocale(value, fallback = null) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  if (!normalized) {
    return fallback;
  }

  const base = normalized.split(/[-_]/)[0];
  return SUPPORTED_LOCALE_SET.has(base) ? base : fallback;
}

export function getPlanTitleText(planId, locale = null) {
  const normalizedPlanId = String(planId || "")
    .trim()
    .toLowerCase();
  const text = PLAN_TITLE_TEXT[normalizedPlanId];
  if (!text) {
    return null;
  }

  const normalizedLocale = normalizePlanLocale(locale, "en");
  return text[normalizedLocale] ?? text.en ?? null;
}

export function getPlanTitleTranslations(planId) {
  const normalizedPlanId = String(planId || "")
    .trim()
    .toLowerCase();
  const text = PLAN_TITLE_TEXT[normalizedPlanId];
  return text ? { ...text } : null;
}
